import { render, staticRenderFns } from "./Hangyefenlei.vue?vue&type=template&id=ece736a4&scoped=true&"
import script from "./Hangyefenlei.vue?vue&type=script&lang=js&"
export * from "./Hangyefenlei.vue?vue&type=script&lang=js&"
import style0 from "./Hangyefenlei.vue?vue&type=style&index=0&id=ece736a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece736a4",
  null
  
)

export default component.exports